/**
 * Pull-cord — animated dark/light toggle (lamp chain).
 */

import { store } from './state';

let cord: HTMLElement;

export function initPullCord(): void {
  cord = document.getElementById('pull-cord') as HTMLElement;
  if (!cord) return;

  cord.addEventListener('click', () => {
    // Animate pull
    cord.classList.add('pulling');
    setTimeout(() => cord.classList.remove('pulling'), 300);

    // Toggle dark mode
    const dark = !store.get().dark;
    store.set({ dark });
    document.body.classList.toggle('dark', dark);
  });
}
